import React from "react";
import ReactPlayer from "react-player";
import { FaPlay } from "react-icons/fa";
import CircularProgressRing from "./CircularProgressRing";

const VideoInterviewStage = ({
  videoSession,
  currentStage,
  currentStatus,
  tabLoading,
  isSharedReport,
  isPlaying,
  setIsPlaying,
  formatDateOnly,
  setShowVideoModal,
  setModalType,
  initiatingVideoCall,
  proctoring,
  cheatingFrames,
  showAllCheatingImages,
  setShowAllCheatingImages,
  selectedProctorIndex,
  setSelectedProctorIndex,
  setOpenProctorLightbox,
  setSelectedProctorImage,
}) => {
  const isMobile = window.innerWidth < 767;

  if (tabLoading) {
    return (
      <div className="loading-overlay">
        <div className="spinner-border" />
      </div>
    );
  }
  return (
  <div>
    <div className="candidate-assessment-details">
      {tabLoading ? (
        <div
          className="loading-overlay"
          style={{
            position: "relative",
            marginTop: 16,
            alignItems: "start",
          }}
        >
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          {(() => {
            const normalize = (v) => (v || "").trim().toLowerCase();
            const videoStatus = normalize(videoSession?.status);
            const safeCurrentStatus = normalize(currentStatus);

            return (
              <>
                {videoStatus === "completed" && videoSession?.result ? (
                  <>
                    <div
                      className="candidate-assessment-items"
                      style={{ width: "100%" }}
                    >
                      {!isMobile &&
                        <div className="candidate-score">
                          <div className="candidate-score-container">
                            <CircularProgressRing
                              percentage={
                                videoSession?.result?.overall_rating ||
                                videoSession?.score?.toFixed?.(2) ||
                                0
                              }
                              label="Video score"
                            />
                          </div>
                        </div>
                      }
                      {isMobile ? 
                      <div class="accordion" id="accordionExample">
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingOne">
                            <button
                              class="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="false"
                              aria-controls="collapseOne"
                            >
                              Overall score
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            class="accordion-collapse collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                              <p
                                style={{
                                  height: "135px",
                                  overflow: "auto",
                                  scrollbarWidth: "none",
                                }}
                              >
                                {videoSession?.result?.technical_skills
                                  ?.description ||
                                  videoSession?.result?.overall_impression}
                              </p>
                              {videoSession?.result?.technical_score && (
                                <p>
                                  Technical score:{" "}
                                  {videoSession?.result?.technical_score.toFixed(2)}
                                  /80
                                </p>
                              )}
                              {videoSession?.result?.behavioral_score && (
                                <p>
                                  Behavioural score:{" "}
                                  {videoSession?.result?.behavioral_score.toFixed(
                                    2,
                                  )}
                                  /20
                                </p>
                              )}
                              {videoSession?.result?.total_score && (
                                <p>
                                  Total score:{" "}
                                  {videoSession?.result?.total_score.toFixed(2)}
                                  /100
                                </p>
                              )}
                              {videoSession?.result?.skill_coverage && (
                                <>
                                  <p>
                                    Skill coverage:{" "}
                                    {Object.entries(
                                      videoSession.result.skill_coverage,
                                    ).map(([skill, score], index) => (
                                      <span
                                        className="candidate-skills"
                                        key={index}
                                      >
                                        {skill} : {score}/10,
                                      </span>
                                    ))}
                                  </p>
                                  <br />
                                </>
                              )}
                              {videoSession?.result?.strengths?.length > 0 && (
                                <>
                                  <div>
                                    <p>Strengths: </p>
                                    <ul>
                                      {videoSession.result.strengths.map(
                                        (point, idx) => (
                                          <li key={idx}>{point}</li>
                                        ),
                                      )}
                                    </ul>
                                  </div>
                                  <br />
                                </>
                              )}
                              {videoSession?.result?.areas_for_improvement?.length >
                                0 && (
                                <div>
                                  <p>Areas of improvement: </p>
                                  <ul>
                                    {videoSession.result.areas_for_improvement.map(
                                      (point, idx) => (
                                        <li key={idx}>{point}</li>
                                      ),
                                    )}
                                  </ul>
                                </div>
                              )}
                              {videoSession?.ended_at && (
                                <p>
                                  Completed On:{" "}
                                  {new Date(videoSession.ended_at)
                                    .toLocaleString(undefined, {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    })
                                    .replace(",", "")}
                                </p>
                              )}
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="headingTwo">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              Video and Transcript
                            </button>
                          </h2>
                          <div
                            id="collapseTwo"
                            class="accordion-collapse collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div class="accordion-body" style={{padding:'0'}}>
                              <ReactPlayer
                                className="assessment-video"
                                url={videoSession?.recording_link}
                                controls={true}
                                playing={isPlaying}
                                width="100%"
                                height="100%"
                                onPlay={() => setIsPlaying(true)}
                                onPause={() => setIsPlaying(false)}
                                config={{
                                  file: {
                                    attributes: {
                                      controlsList: "nodownload",
                                      preload: "metadata",
                                    },
                                  },
                                }}
                              />
                              <div
                                className="candidate-assessment-transcript"
                                style={{
                                  height: "385px",
                                  overflow: "auto",
                                  scrollbarWidth: "thin",
                                  padding:'0 20px'
                                }}
                              >
                                <h4 style={{margin:'8px 0'}}>Transcript</h4>
                                {videoSession?.transcripts?.map((msg, idx) => {
                                  if (!msg.content?.trim()) return null;
                                  const isAgent = msg.content_by === "AI";
                                  const speaker = isAgent ? "Agent voice" : msg.content_by;
                                  return (
                                    <div
                                      className="transcript"
                                      key={idx}
                                      style={{ marginBottom: "10px" }}
                                    >
                                      <div className="transcript-text">
                                        {isAgent ? (
                                          <img
                                            src="/images/candidate-example.jpeg"
                                            alt="avatar"
                                          />
                                        ) : (
                                          <div className="user-avatar">
                                            {msg.content_by?.charAt(0).toUpperCase() || "U"}
                                          </div>
                                        )}
                                        &nbsp;<h5>{speaker}</h5>
                                      </div>
                                      <p>{msg.content}</p>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      :   
                      <div
                        className="assessment-score d-flex"
                        style={{ gap: "20px", width: "100%" }}
                      >
                        {/* LEFT SECTION */}
                        <div
                          style={{
                            width: "50%",
                            paddingRight: "20px",
                            borderRight: "1px solid #ccc",
                          }}
                        >
                          <h5>Overall score</h5>
                          <p
                            style={{
                              height: "135px",
                              overflow: "auto",
                              scrollbarWidth: "none",
                            }}
                          >
                            {videoSession?.result?.technical_skills
                              ?.description ||
                              videoSession?.result?.overall_impression}
                          </p>
                        </div>

                        {/* RIGHT SECTION */}
                        <div
                          style={{
                            width: "50%",
                            height: "150px",
                            overflowX: "auto",
                            scrollbarWidth: "thin",
                          }}
                        >
                          {videoSession?.result?.technical_score && (
                            <p>
                              Technical score:{" "}
                              {videoSession?.result?.technical_score.toFixed(2)}
                              /80
                            </p>
                          )}

                          {videoSession?.result?.behavioral_score && (
                            <p>
                              Behavioural score:{" "}
                              {videoSession?.result?.behavioral_score.toFixed(
                                2,
                              )}
                              /20
                            </p>
                          )}

                          {videoSession?.result?.total_score && (
                            <p>
                              Total score:{" "}
                              {videoSession?.result?.total_score.toFixed(2)}
                              /100
                            </p>
                          )}

                          <br />

                          {videoSession?.result?.skill_coverage && (
                            <>
                              <p>
                                Skill coverage:{" "}
                                {Object.entries(
                                  videoSession.result.skill_coverage,
                                ).map(([skill, score], index) => (
                                  <span
                                    className="candidate-skills"
                                    key={index}
                                  >
                                    {skill} : {score}/10,
                                  </span>
                                ))}
                              </p>
                              <br />
                            </>
                          )}

                          {videoSession?.result?.strengths?.length > 0 && (
                            <>
                              <div>
                                <p>Strengths: </p>
                                <ul>
                                  {videoSession.result.strengths.map(
                                    (point, idx) => (
                                      <li key={idx}>{point}</li>
                                    ),
                                  )}
                                </ul>
                              </div>
                              <br />
                            </>
                          )}

                          {videoSession?.result?.areas_for_improvement?.length >
                            0 && (
                            <div>
                              <p>Areas of improvement: </p>
                              <ul>
                                {videoSession.result.areas_for_improvement.map(
                                  (point, idx) => (
                                    <li key={idx}>{point}</li>
                                  ),
                                )}
                              </ul>
                            </div>
                          )}

                          {videoSession?.ended_at && (
                            <p>
                              Completed On:{" "}
                              {new Date(videoSession.ended_at)
                                .toLocaleString(undefined, {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                })
                                .replace(",", "")}
                            </p>
                          )}
                        </div>
                      </div>
                    }
                    </div>
                  </>
                ) : (
                  <>
                    {!currentStage ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        {!isSharedReport && (
                          <button
                            className="candidate-assessment-calling"
                            onClick={() => {
                              setShowVideoModal(true);
                              setModalType("video");
                            }}
                            disabled={initiatingVideoCall}
                          >
                            {initiatingVideoCall
                              ? "Initiating call..."
                              : "Schedule a video interview"}
                          </button>
                        )}
                      </div>
                    ) : safeCurrentStatus === "assigned" ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        <p>Video Interview assigned, yet to be completed</p>
                      </div>
                    ) : safeCurrentStatus === "not scheduled" ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        <p>Video Interview assigned, yet to be scheduled</p>
                      </div>
                    ) : safeCurrentStatus === "scheduled" ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        <p>
                          Video Interview sent. Due at{" "}
                          {formatDateOnly(currentStage.expire_at)}
                        </p>
                      </div>
                    ) : safeCurrentStatus === "ongoing" ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        <p>Video Interview is in progress</p>
                      </div>
                    ) : safeCurrentStatus === "expired" ? (
                      <div
                        className="candidate-assessment-items"
                        style={{
                          border: "none",
                          width: "100%",
                          display: "block",
                        }}
                      >
                        {!isSharedReport && (
                          <button
                            className="candidate-assessment-calling"
                            onClick={() => {
                              setShowVideoModal(true);
                              setModalType("video");
                            }}
                            disabled={initiatingVideoCall}
                            style={{ width: "unset" }}
                          >
                            {initiatingVideoCall
                              ? "Initiating call..."
                              : "Schedule a video interview again"}
                          </button>
                        )}
                        <p
                          className="d-flex align-items-center"
                          style={{ color: "#FF5733" }}
                        >
                          video call stage expired
                        </p>
                      </div>
                    ) : ["failed", "not completed", "revoked"].includes(
                        safeCurrentStatus,
                      ) ? (
                      <div
                        className="candidate-assessment-items"
                        style={{
                          border: "none",
                          width: "100%",
                          display: "block",
                        }}
                      >
                        {!isSharedReport && (
                          <button
                            className="candidate-assessment-calling"
                            onClick={() => {
                              setShowVideoModal(true);
                              setModalType("video");
                            }}
                            disabled={initiatingVideoCall}
                            style={{ width: "unset" }}
                          >
                            {initiatingVideoCall
                              ? "Initiating call..."
                              : "Schedule a video interview again"}
                          </button>
                        )}
                        <p
                          className="d-flex align-items-center"
                          style={{ color: "#FF5733" }}
                        >
                          video call was attempted but not responded by the
                          candidate.
                        </p>
                      </div>
                    ) : safeCurrentStatus === "completed" &&
                      videoSession?.result ? (
                      <>
                        <div
                          className="candidate-assessment-items"
                          style={{ width: "100%" }}
                        >
                          <div className="candidate-score">
                            <div className="candidate-score-container">
                              <CircularProgressRing
                                percentage={
                                  videoSession?.result?.overall_rating || 0
                                }
                                label="Video score"
                              />
                            </div>
                          </div>
                          <div className="assessment-score">
                            <h5>Overall score</h5>
                            <p
                              style={{
                                height: "135px",
                                width: "70%",
                                overflow: "auto",
                                scrollbarWidth: "none",
                              }}
                            >
                              {
                                videoSession?.result?.technical_skills
                                  ?.description
                              }
                            </p>
                          </div>
                        </div>
                      </>
                    ) : safeCurrentStatus === "completed" &&
                      !videoSession?.result ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        <p>Video interview completed, waiting for result</p>
                      </div>
                    ) : (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        <p>Status pending or unknown</p>
                      </div>
                    )}
                  </>
                )}
              </>
            )
          })()}
        </>
      )}
    </div>
    {!isMobile &&
      <div className="candidate-assessment-details">
        {tabLoading ? (
          <div
            className="loading-overlay"
            style={{
              position: "relative",
              marginTop: 16,
              alignItems: "start",
            }}
          >
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {(currentStatus === "COMPLETED" && videoSession?.result) ||
            (videoSession?.status === "Completed" && videoSession?.result) ? (
              <>
                <div
                  className="candidate-assessment-items"
                  style={{ width: "100%" }}
                >
                  <div className="candidate-assessment-video">
                    <h5>Video interview</h5>
                    <ReactPlayer
                      className="assessment-video"
                      url={videoSession?.recording_link}
                      controls={true}
                      playing={isPlaying}
                      width="100%"
                      height="100%"
                      onPlay={() => setIsPlaying(true)}
                      onPause={() => setIsPlaying(false)}
                      config={{
                        file: {
                          attributes: {
                            controlsList: "nodownload",
                            preload: "metadata",
                          },
                        },
                      }}
                    />
                    {!isPlaying &&
                    videoSession?.recording_link_status === "Completed" ? (
                      <div
                        onClick={() => setIsPlaying(true)}
                        className="player-svg"
                      >
                        <FaPlay size={30} color="#FFFFFF" />
                      </div>
                    ) : null}
                  </div>
                  <div
                    className="candidate-assessment-transcript"
                    style={{
                      height: "385px",
                      overflow: "auto",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <h4>Transcript</h4>
                    {videoSession?.transcripts?.map((msg, idx) => {
                      if (!msg.content?.trim()) return null;
                      const isAgent = msg.content_by === "AI";
                      const speaker = isAgent ? "Agent voice" : msg.content_by;
                      return (
                        <div
                          className="transcript"
                          key={idx}
                          style={{ marginBottom: "10px" }}
                        >
                          <div className="transcript-text">
                            {isAgent ? (
                              <img
                                src="/images/candidate-example.jpeg"
                                alt="avatar"
                              />
                            ) : (
                              <div className="user-avatar">
                                {msg.content_by?.charAt(0).toUpperCase() || "U"}
                              </div>
                            )}
                            &nbsp;<h5>{speaker}</h5>
                          </div>
                          <p>{msg.content}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : null}
          </>
        )}
      </div>
    }
    {proctoring && cheatingFrames.length > 0 && (
      <div className="candidate-assessment-details mt-4">
        <div className="image-lists">
          <h4>Proctoring Analysis</h4>
          <div className="proctoring-report">
            <div className="proctoring-report-item">
              <div className="proctoring-report-count">
                <h6>{cheatingFrames.length}</h6>
              </div>
              <p>Cheating detected in frames</p>
            </div>
          </div>
          <div className="d-flex flex-wrap" style={{ gap: "12px" }}>
            {(showAllCheatingImages
              ? cheatingFrames
              : cheatingFrames.slice(0, 8)
            ).map((frame, index) => (
              <div
                key={index}
                className="image-list"
                style={{
                  width: isMobile? '100%' :"160px",
                  height: isMobile? 'auto' : "90px",
                  overflow: "hidden",
                  borderRadius: "8px",
                  cursor: "pointer",
                  position: "relative",
                  border: "3px solid red",
                }}
              >
                <img
                  src={frame.image_url}
                  className="w-100 h-100"
                  style={{ objectFit: "cover" }}
                  alt=""
                  data-bs-toggle="tooltip"
                  title={frame?.llm_eval?.summary || ""}
                  onClick={() => {
                    setSelectedProctorIndex(index);
                    setSelectedProctorImage(frame.image_url);
                    setOpenProctorLightbox(true);
                  }}
                />
              </div>
            ))}
          </div>
          {cheatingFrames.length > 8 && (
            <div
              style={{
                width: "100%",
                textAlign: "center",
                marginTop: "15px",
                cursor: "pointer",
                fontWeight: 600,
                color: "#0048b7",
              }}
              onClick={() => setShowAllCheatingImages(!showAllCheatingImages)}
            >
              {showAllCheatingImages ? "View Less" : "View All"}
            </div>
          )}
        </div>
      </div>
    )}
  </div>
  );
};

export default VideoInterviewStage;
